import React, { FC } from 'react';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';

import ToolCardIcon3 from '../../../images/solutions/airflow.svg';
import ToolCardIcon1 from '../../../images/solutions/delta-lake.svg';
import ToolCardIcon5 from '../../../images/solutions/mlflow.svg';
import ToolCardIcon7 from '../../../images/solutions/pytorch.svg';
import ToolCardIcon2 from '../../../images/solutions/tool-card-2-icon.svg';
import ToolCardIcon4 from '../../../images/solutions/tool-card-4-icon.svg';
import ToolCardIcon6 from '../../../images/solutions/tool-card-6-icon.svg';
import ToolCardIcon8 from '../../../images/solutions/tool-card-8-icon.svg';
import {
  ArtToolsStyled,
  UseCasesDiagonalGrayTop,
  Title,
  ToolsContainer,
  Tool,
  ToolIconContainer,
  ToolTitle,
} from './style';

interface Props {}

const ArtTools: FC<Props> = () => {
  const { t } = useTranslation();
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
  });
  return (
    <ArtToolsStyled ref={targetRef}>
      <UseCasesDiagonalGrayTop />
      <div className="container">
        <Title
          className={
            isInViewport ? 'animate__animated animate__fadeInUp' : 'hide'
          }
          dangerouslySetInnerHTML={{
            __html: t('SolutionArtToolsTitle'),
          }}
        />
      </div>
      <ToolsContainer>
        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon1} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard1Title')}</ToolTitle>
        </Tool>

        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInDown animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon2} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard2Title')}</ToolTitle>
        </Tool>

        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon3} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard3Title')}</ToolTitle>
        </Tool>

        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInDown animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon4} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard4Title')}</ToolTitle>
        </Tool>

        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon5} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard5Title')}</ToolTitle>
        </Tool>

        <Tool
          className={
            isInViewport
              ? 'animate__animated animate__fadeInDown animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon6} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard6Title')}</ToolTitle>
        </Tool>

        <Tool
          ref={targetRef}
          className={
            isInViewport
              ? 'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon7} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard7Title')}</ToolTitle>
        </Tool>

        <Tool
          ref={targetRef}
          className={
            isInViewport
              ? 'animate__animated animate__fadeInDown animate__faster animate__delay-1s'
              : 'hide'
          }
        >
          <ToolIconContainer>
            <img src={ToolCardIcon8} alt="icon" />
          </ToolIconContainer>
          <ToolTitle>{t('SolutionToolCard8Title')}</ToolTitle>
        </Tool>
      </ToolsContainer>
    </ArtToolsStyled>
  );
};

export default ArtTools;
